export default __webpack_public_path__ + "static/staffy-wordmark-orange-4979cad4dc302c7bef1535ae39e2fead.svg";